export default __webpack_public_path__ + "static/media/icon-next-double.6fa0951e.svg";